import context, { IAppUserContext } from '@truckdown/components-systems';
import { IInitializer, IUserContext } from '@truckdown/systems';

//Styles
import './Styles.less';

//images
import './Images/screens.png';
import './Images/logo.mobile.truckdown.png';
import './Images/appstore.png';
import './Images/google_play_narrow.png';
import './Images/gps.png';
import './Images/fleet_header.png';
import './Images/fleet-header-mob.png';
import './Images/mobile-apps-hero.jpg';
import './Images/advertise-header.png';
import './Images/smartway_hero.jpg';
import './Images/dispatcher.jpg';
import './Images/driver.jpg';
import './Images/driver-happy.jpg';
import './Images/advertise-header-mob.png';
import './Images/verification-hero.png';
import './Images/td_badge_stock.png';
import './Images/td_badge_pro.png';
import './Images/td_badge_elite.png';

import './Images/search_screen.png';
import './Images/services_screen.png';
import './Images/rating_screen.png';
import './Images/note_screen.png';
import './Images/history_screen.png';
import './Images/sync_screen.png';

import './Images/scam-icon.png';
import './Images/time-money-icon.png';
import './Images/wrench-icon.png';

import './Images/tablet_td.png';
import './Images/tablet_ratings.png';

import './Images/service-requests.png';
import './Images/service-requests-1.png';

import './Images/fleet-manager-dan.jpg';
import './Images/dispatch_jenna.jpg';
import './Images/problem.jpg';
import './Images/solution-image.jpg';
import './Images/repair.jpg';
import './Images/tires-header.jpg';

import registerLocations from '@truckdown/locations';
import components from '@truckdown/components-locations';

import sectionedContent from "./components/SectionedContent/SectionedContent.vue";
import reviews from "./components/Reviews.vue";
import srFleetRegisterButton from "./components/SRFleetRegisterButton/SRFleetRegisterButton.vue";

registerLocations(context);
components.registerPrerequisites(context);

class ComponentInitializer implements IInitializer {
    name: string = 'LoggingComponentInitializer';
    order: number = 0;

    async initialize(context: IUserContext): Promise<void> {
        let app = (context as IAppUserContext).app;

        app.component('sectioned-content', sectionedContent);
        app.component('reviews', reviews);

        app.component('sr-fleet-register-button', srFleetRegisterButton);
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new ComponentInitializer();
    }
});

context.initialize().then(() => {
    (window as any).isSysInitialized = true;
    console.log('System initialized');
});